<div class="page-breadcrumb">
    <div class="row">
        <div class="col-7 align-self-center">
            <!-- <div class="d-flex align-items-center">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <a rouetLink="/mainview/dashboard" class="link">Dashboard</a>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page"> Open Orders Management</li>
                    </ol>
                </nav>
            </div> -->
            <h4 class="page-title">Open Orders Details</h4>
        </div>

    </div>
</div>


<!-- Container fluid  -->
<!-- ============================================================== -->
<div class="container-fluid" style="margin-top: 20px">

    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <div id="zero_config_wrapper"
                            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">

                            <div class="row">
                               
                                <div class="col-md-11">
                                    <div id="zero_config_filter" class="dataTables_filter">
                                        <button style="background-color: #e0e09e" (click)="filter()">
                                            <i class="fa fa-filter" aria-hidden="true"></i>
                                            Filter</button>
                                    </div>

                                </div>
                                <div class="col-md-1">

                                    <div id="zero_config_filter" class="dataTables_filter" *ngIf="export==true">
                                        <button style="background-color: #e0e09e" (click)="exportTable()">
                                            <i class="fa fa-download" aria-hidden="true"></i>
                                            Export</button>
                                    </div>

                                </div>
                            </div>
                            <div *ngIf="showFilter" style="background-color: #e0e09e;width: 895px;">
                                <div class="container-fluid" style="color: black">
                                  
                                    <input type="radio" id="emailId" name="gender" [(ngModel)]="filterValueSelected"
                                        value="ei" (change)="applyCustomizedFilter()" style="margin-top: 29px;"> Account Email Id &nbsp;&nbsp;
                                   
                                    <input type="radio" id="orderid" name="gender" style="margin-top: 29px;" [(ngModel)]="filterValueSelected"
                                        value="oi" (change)="applyCustomizedFilter()"> Order Id &nbsp;&nbsp;
                                   


                                </div>
                                <div style="margin-left: 820px">

                                    <button class="btn btn-dark" (click)="filter()">Cancel</button>

                                </div>
                            </div>

                            <div>
                                <div>
                                    <mat-form-field *ngIf="showCustomisedSearch">

                                        <input class="search" placeholder="Search" matInput [(ngModel)]="searchValue"
                                            (keyup)="applyCustomizedFilterSearch(searchValue)">

                                    </mat-form-field>
                                    <mat-form-field *ngIf="!showCustomisedSearch">
                                        <input class="search" placeholder="Search" matInput
                                            (keyup)="applyFilter($event.target.value)">

                                    </mat-form-field>

                                </div>
                                <div class="table-responsive">
                                    <table class="table" id="Example table" mat-table
                                        [dataSource]="dataSource" matSort style=" margin-top: 30px;">
                                        <ng-container matColumnDef="accountEmailId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Account Email Id</th>
                                            <td *matCellDef="let row" style="padding-left: 14px;">{{row.accountEmailId}}</td>
                                        </ng-container>
                                        <!-- <ng-container matColumnDef="AccountEmailId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Account Email Id</th>
                                            <td *matCellDef="let row">{{row.AccountEmailId}}</td>
                                        </ng-container> -->
                                        <ng-container matColumnDef="vendorId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Vendor Id</th>
                                            <td *matCellDef="let row">{{row.vendorId}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="orderId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Order Id</th>
                                            <td *matCellDef="let row">{{row.orderId}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="button">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Details Of Products
                                            </th>
                                            <td *matCellDef="let row;"> 
                                               
                                                    <button data-toggle="modal" (click)="getAllProductDetailsByOrderId(row._id)"
                                                    data-target="#exampleModalCenter">Product Details</button>
                                              
                                          
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="createdDate">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Ordered Date</th>
                                            <td *matCellDef="let row" >{{row.createdDate|date}}</td>
                                        </ng-container>
                                       
                                        <!-- <ng-container matColumnDef="ProductId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Product Id</th>
                                            <td *matCellDef="let row">{{row.ProductId}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="ProductName">
                                             <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Name</th>
                                            <td *matCellDef="let row">{{row.ProductName}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="Description">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Description</th>
                                            <td *matCellDef="let row">{{row.Description}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="OrderedQuantity">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Ordered Quantity</th>
                                            <td *matCellDef="let row">{{row.OrderedQuantity}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="StockUnit">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Stock Unit</th>
                                            <td *matCellDef="let row">{{row.StockUnit}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="PurchaseDate">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Purchase Date</th>
                                            <td *matCellDef="let row">{{row.PurchaseDate|date}}</td>
                                        </ng-container>
                                      
                                        <ng-container matColumnDef="Price">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Purchase Price</th>
                                            <td *matCellDef="let row">{{row.Price}}</td>
                                        </ng-container>
                                       
                                       
                                        <ng-container matColumnDef="ProductStatus">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Status</th>
                                            <td *matCellDef="let row">{{row.ProductStatus}}</td>
                                        </ng-container>
                                       
                                        <ng-container matColumnDef="AddedByUserId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Added By UserId</th>
                                            <td *matCellDef="let row">{{row.AddedByUserId}}</td>
                                        </ng-container> -->
                                     


                                        <tr mat-header-row *matHeaderRowDef='displayedColumns'>
                                        </tr>
                                        <tr mat-row *matRowDef="let row;columns:displayedColumns"></tr>
                                    </table>
                                </div>

                            </div>

                        </div>
                    </div>
                    <mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25,100]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>




<!-- Modal -->
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="viewMyPost">Products Details</h2>
                <button type="button" class="close" data-dismiss="modal">X
                </button>
            </div>
            <div class="modal-body">
                <div class="table-responsive">
                    <table class="table" id="Example table" mat-table
                        [dataSource]="dataSourceProductDetails" matSort style=" margin-top: 30px;">
                      
                       
                      
                        <ng-container matColumnDef="productName">
                             <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Name</th>
                            <td *matCellDef="let row">{{row.productdetails.productName}}</td>
                        </ng-container>
                        <ng-container matColumnDef="productImage">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Image</th>
                            <td *matCellDef="let row" style="white-space: nowrap;">
                              
                                <button class="dropdown-item" data-toggle="modal"
                                *ngIf="write==true" data-target="#responsiveImages"
                                style="color:rgb(30, 110, 124)" (click)="viewImages(row.productdetails._id)">
                               View
                                </button>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="description">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Description</th>
                            <td *matCellDef="let row">{{row.productdetails.description}}</td>
                        </ng-container>
                       
                        <ng-container matColumnDef="updatingQuantity">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Quantity</th>
                            <td *matCellDef="let row">{{row.updatingQuantity}}</td>
                        </ng-container>
                      
                       
                        <ng-container matColumnDef="productStatus">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Status</th>
                            <td *matCellDef="let row">{{row.productdetails.productStatus}}</td>

                        </ng-container>
                       
                     


                        <tr mat-header-row *matHeaderRowDef='displayedColumnsProductDetails'>
                        </tr>
                        <tr mat-row *matRowDef="let row;columns:displayedColumnsProductDetails"></tr>
                    </table>
                </div>
            
            </div>
        </div>
    </div>
</div>
<div id="responsiveImages" class="modal fade" tabindex="-1" data-width="760" style="display: none;">
    <div class="modal-dialog" id="box" style="margin-left: 300px">
        <div class="modal-content" style="width:900px">
            <div class="modal-header">
                <button type="button" class="close btn-danger" data-dismiss="modal">X
                </button>
            </div>
            <div class="modal-body">
                <img style="text-indent: -10000px"  src="{{myurl+'Misc/Images/productImages/'+productImageId+'_0'}}"
                width="100" height="100" />
                <img   style="text-indent: -10000px" src="{{myurl+'Misc/Images/productImages/'+productImageId+'_1'}}"
                width="100" height="100" />
                <img  style="text-indent: -10000px"  src="{{myurl+'Misc/Images/productImages/'+productImageId+'_2'}}"
                width="100" height="100" />
            </div>
        </div>
    </div>
</div>